import {
  ModelConceptRelationship,
  ModelConceptRelationshipLabel,
} from 'src/containers/ProjectDiagram/types/data';
import { DiagramSnapshot } from 'src/containers/ProjectDiagram/types/diagram';
import {
  isModelConceptRelationship,
  isModelConceptRelationshipLabel,
} from 'src/containers/ProjectDiagram/utils/data';
import { getModelConceptClassValue } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';

export const getPreviousRelationship = (
  diagram: DiagramSnapshot,
  iri: string
) =>
  diagram.model.modelData.draftData?.prevLinkDataArray.find(
    (linkData): linkData is ModelConceptRelationship =>
      isModelConceptRelationship(linkData) && linkData.value === iri
  );

export const getPreviousRelationshipConnection = (
  diagram: DiagramSnapshot,
  data: ModelConceptRelationship | ModelConceptRelationshipLabel
) => {
  if (isModelConceptRelationship(data)) {
    return diagram.model.modelData.draftData?.prevLinkDataArray.find(
      (linkData): linkData is ModelConceptRelationship =>
        isModelConceptRelationship(linkData) && linkData.key === data.key
    );
  }

  if (isModelConceptRelationshipLabel(data)) {
    return diagram.model.modelData.draftData?.prevNodeDataArray.find(
      (nodeData): nodeData is ModelConceptRelationshipLabel =>
        isModelConceptRelationshipLabel(nodeData) && nodeData.key === data.key
    );
  }

  return undefined;
};

/**
 * Returns sets of source/target class IRIs that were added to
 * a given relationship in preview mode.
 *
 * @returns {{ addedSources: Set<string>, addedTargets: Set<string> }}
 */
export const getAddedRelationshipSourcesAndTargets = ({
  isNewRelationship,
  relationshipIri,
  diagram,
}: {
  isNewRelationship: boolean;
  relationshipIri: string;
  diagram: DiagramSnapshot;
}) => {
  const addedSources = new Set<string>();
  const addedTargets = new Set<string>();

  diagram.model.linkDataArray.forEach((linkData) => {
    if (
      isModelConceptRelationship(linkData) &&
      linkData.value === relationshipIri
    ) {
      if (linkData.from) {
        addedSources.add(getModelConceptClassValue(linkData.from));
      }
      if (linkData.to) {
        addedTargets.add(getModelConceptClassValue(linkData.to));
      }
    }
  });

  if (!isNewRelationship) {
    diagram.model.modelData.draftData?.prevLinkDataArray.forEach((linkData) => {
      if (
        isModelConceptRelationship(linkData) &&
        linkData.value === relationshipIri
      ) {
        if (linkData.from) {
          addedSources.delete(getModelConceptClassValue(linkData.from));
        }
        if (linkData.to) {
          addedTargets.delete(getModelConceptClassValue(linkData.to));
        }
      }
    });
  }

  return { addedSources, addedTargets };
};
